// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2i-6";
export var headerCell = "_2i-2";
export var loadingStateContent = "_2i-8";
export var rowWrapper = "_2i-4";
export var stickyAggregationCell = "_2i-b";
export var stickyAggregationRow = "_2i-7";
export var stickyColumnCell = "_2i-a";
export var stickyColumnHeaderCell = "_2i-9";
export var table = "_2i-1";
export var virtualRowWrapper = "_2i-5";
export var virtualTableContainer = "_2i-0";
export var white = "_2i-3";